import React, { useEffect, useRef } from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const CTASection = () => {
  const { t } = useLanguage();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="cta"
      ref={sectionRef}
      className="py-32 md:py-48 bg-soft-black relative overflow-hidden"
      data-testid="cta-section"
    >
      {/* Decorative lines */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-32 h-px bg-gradient-to-r from-transparent to-white/10" />
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-32 h-px bg-gradient-to-l from-transparent to-white/10" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 
            className="font-serif text-3xl md:text-5xl lg:text-6xl font-normal tracking-tight text-white mb-8 animate-on-scroll"
            data-testid="cta-title"
          >
            {t.cta.title}
          </h2>
          <p 
            className="text-zinc-500 text-base md:text-lg mb-14 max-w-xl mx-auto font-light animate-on-scroll"
            style={{ transitionDelay: '0.1s' }}
            data-testid="cta-subtitle"
          >
            {t.cta.subtitle}
          </p>

          {/* CTA Buttons */}
          <div 
            className="flex flex-col sm:flex-row gap-4 justify-center animate-on-scroll"
            style={{ transitionDelay: '0.2s' }}
          >
            <button 
              onClick={scrollToContact}
              className="btn-primary flex items-center justify-center gap-3 group"
              data-testid="cta-button-primary"
            >
              <span>{t.cta.button1}</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            <button 
              onClick={scrollToContact}
              className="btn-secondary flex items-center justify-center"
              data-testid="cta-button-secondary"
            >
              {t.cta.button2}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
